import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {FaxModel} from '../../api/models/fax-model';
import {LocalFaxService} from '../local-fax.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NotificationService} from '../../notification/notification.service';
import {ContactTagLookupModel} from '../../api/models/contact-tag-lookup-model';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRecipientsMultiselectComponent } from '../../editors/mat-recipients-multiselect/mat-recipients-multiselect.component';
import { NgIf } from '@angular/common';
import { PdfViewerComponent } from '../../editors/pdf-viewer/pdf-viewer.component';

export interface FaxRetryDialogData {
  faxData: FaxModel;
}

@Component({
    selector: 'app-fax-retry-dialog',
    templateUrl: './fax-retry-dialog.component.html',
    styleUrls: ['./fax-retry-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        ReactiveFormsModule,
        MatRecipientsMultiselectComponent,
        NgIf,
        PdfViewerComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class FaxRetryDialogComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup;
  contactsControl = new UntypedFormControl([], [Validators.required]);
  submitted: boolean;
  serverError: boolean;
  public previewPdf1: string;
  public previewPdf2: string;
  contacts: ContactTagLookupModel[] = [];

  constructor(public dialogRef: MatDialogRef<FaxRetryDialogComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: FaxRetryDialogData,
              public localFaxService: LocalFaxService,
              private notificationService: NotificationService,
              private fb: UntypedFormBuilder
  ) {
  }

  ngOnInit() {
    console.log('Fax preview init', this.data);
    if (this.data.faxData.orgFilename1) {
      this.previewPdf1 = `/api/fax/preview-fax/${this.data.faxData.callerId}/${this.data.faxData.faxId}`;
    }
    if (this.data.faxData.orgFilename2) {
      this.previewPdf2 = `/api/fax/preview-fax/${this.data.faxData.callerId}/${this.data.faxData.faxId}?second=true`;
    }

    this.contacts = this.data.faxData.contactTo ? [{
      phoneNumber: this.data.faxData.contactTo.phoneNumber,
      name: this.data.faxData.contactTo.name,
      type: 'Contacts',
      uniqueKey: `${this.data.faxData.contactTo.phoneNumber || ''}|Contacts||''}`,
      communicationType: 0,
      isOptedIn: false
    }] : [{
      phoneNumber: this.data.faxData.tnTo,
      name: '',
      type: 'Contacts',
      uniqueKey: `${this.data.faxData.tnTo || ''}|Contacts||''}`,
      communicationType: 0,
      isOptedIn: false
    }];
    this.contactsControl = new UntypedFormControl(this.contacts, [Validators.required]);
    this.form = this.fb.group({
        'numbersTo': this.contactsControl
      }
    );
  }

  ngOnDestroy() {
  }

  onRetry() {
    if (this.form.valid) {
      this.submitted = true;
      const formModel = this.form.getRawValue();
      const numbersTo = formModel.numbersTo.map(x => x.phoneNumber);

      this.localFaxService.retryFax({
        faxId: this.data.faxData.faxId,
        numberFrom: this.data.faxData.tnFrom,
        numbersTo: numbersTo
      }).then(() => {
        this.notificationService.notifySuccess('Fax submitted successfully');
        this.dialogRef.close(true);
      }).catch((error) => {
        console.error(error);
        this.notificationService.notifyDanger('Error occur while submitting fax. Please try again later or check if form data is valid.');
      }).finally(() => {
        this.submitted = false;
      });
    }
  }

  afterPdfLoaded() {
    window.dispatchEvent(new Event('resize'));
  }
}
